import React, { useContext, useState } from 'react'
import moment from 'moment'
import { map } from 'lodash'
import { Context } from '../../../Store'
import { Grid } from '@material-ui/core'
import { FormDatePicker } from './FormDatePicker'
import { useTranslation } from 'react-i18next'
import { getMaxDate } from './LegacyValidations'
import { RENT_RETENTION_TYPE } from '../../../constants'
import { ErrorMessage } from './ErrorMessage'

export const CheckOutDate = () => {
  const [state, dispatch] = useContext(Context)
  const [endDate, setEndDate] = useState(state?.end_date)
  const { t } = useTranslation()

  const { property } = state
  const { minStay = 1, maxStay, notAvailablePeriods } = property

  const remappedNotAvailablePeriods = map(notAvailablePeriods, (period) => ({
    endDate: moment(period[1]),
    startDateWithMinStay: moment(period[0]).subtract(minStay, 'months'),
    startDate: moment(period[0]),
  }))

  const onChangeEndDate = (date) => {
    const momentEndDate = moment(date).toDate()
    dispatch({ type: 'SET_END_DATE', payload: momentEndDate })
    setEndDate(momentEndDate)
  }

  return (
    state.over_12_months === RENT_RETENTION_TYPE.UNDER
    && <Grid item xs={12} lg={11} direction='column'>
        <FormDatePicker
          name="end_date"
          label={t('booking.checkIn.dateCheckOut.placeholder')}
          value={endDate}
          onChange={(props) => {onChangeEndDate(props.format('YYYY-MM-DD'))}}
          notAvailablePeriods={remappedNotAvailablePeriods}
          minDate={moment(state.start_date).add(minStay, 'months').subtract(1, 'day').toISOString(true)}
          maxDate={getMaxDate(state.start_date, notAvailablePeriods, maxStay)}
          error={state?.error?.end_date}
        />
        {state?.error?.end_date && <ErrorMessage error={state?.error?.end_date} />}
      </Grid>
  )
}